import React, { forwardRef, useRef, useState, useImperativeHandle } from 'react';
import { VegaModal, VegaFlex, VegaButton } from '@heartlandone/vega-react';
import { CONFIRMATION_MESSAGE_PREFIX } from 'Containers/Requests/Constant';

const ForwardConfirmDialog = forwardRef(function ConfirmDialog(_, ref) {
  const defaultProps = {
    title: 'Delete',
    message: `${CONFIRMATION_MESSAGE_PREFIX} delete the item?`,
    actionButtons: [
      {
        label: 'Cancel',
        danger: true
      },
      {
        label: 'Ok',
        onClick: () => {},
        danger: true
      }
    ],
    backdrop: 'default'
  };

  const modelRef = useRef();
  const [propsData, setPropsData] = useState(defaultProps);

  const {
    title,
    message,
    content1,
    actionButtons: [cancelButtonProps, confirmButtonProps],
    backdrop
  } = propsData;

  useImperativeHandle(ref, () => ({
    open: (props) => {
      modelRef.current.modal('show');
      setPropsData({ danger: true, ...props });
    },
    close: closeModal
  }));

  const closeModal = () => {
    modelRef.current.modal('hide');
  };

  const onCancelClick = () => {
    closeModal();
  };

  const onConfirmClick = () => {
    closeModal();
    confirmButtonProps.onClick();
  };

  return (
    <VegaModal ref={modelRef} size="480" modalTitle={title} padding="size-24" onVegaClose={closeModal} backdrop={backdrop}>
      <VegaFlex direction={'col'} gap={'size-24'}>
        <div>{message}</div>
        {
          content1 && <div>{content1}</div>
        }
        <VegaFlex direction={'row'} gap={'size-12'} justifyContent={'end'} useNativeFlex={true}>
          <VegaButton
            size="small"
            label={cancelButtonProps.label}
            variant={cancelButtonProps.variant || 'secondary'}
            {...(cancelButtonProps.danger === false ? {} : { danger: true })}
            onVegaClick={onCancelClick}
          ></VegaButton>
          <VegaButton
            size="small"
            label={confirmButtonProps.label}
            variant={confirmButtonProps.variant || 'primary'}
            {...(confirmButtonProps.danger === false ? {} : { danger: true })}
            onVegaClick={onConfirmClick}
          ></VegaButton>
        </VegaFlex>
      </VegaFlex>
    </VegaModal>
  );
});

ForwardConfirmDialog.displayName = 'ConfirmDialog';

export default ForwardConfirmDialog;
